// Centralized API URL helper
import { API_URL } from './config';

export function getApiBaseUrl(): string {
  return API_URL;
}

export function apiUrl(path: string): string {
  const base = getApiBaseUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

